var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/js/Components/CheckboxList.tsx
import useHybridInput from "@enymo/react-hybrid-input-hook";
import React, { createContext as createContext2, useCallback, useContext as useContext2 } from "react";

// src/js/Hooks/ErrorContext.tsx
import { createContext, useContext } from "react";
var Context = createContext(void 0);
var ErrorProvider = Context.Provider;
var useError = () => useContext(Context);

// src/js/Components/CheckboxList.tsx
var Context2 = createContext2(void 0);
var useCheckboxList = () => useContext2(Context2);
function CheckboxList({
  name,
  value: externalValue,
  onChange: externalOnChange,
  options,
  error: externalError,
  children
}) {
  const { value, onChange, error } = useHybridInput({ name, externalValue, externalOnChange, externalError, options, defaultValue: [] });
  const handleToggle = useCallback((name2) => {
    onChange(value.includes(name2) ? value.filter((value2) => value2 !== name2) : [...value, name2]);
  }, [value, onChange]);
  return /* @__PURE__ */ React.createElement(Context2.Provider, { value: { value, toggle: handleToggle } }, /* @__PURE__ */ React.createElement(ErrorProvider, { value: error }, children));
}

// src/js/Components/GlissadeInput.tsx
import classNames from "classnames";
import React2, { useMemo } from "react";
import { useFormContext } from "react-hook-form";
function GlissadeInput(_a) {
  var _b = _a, {
    className,
    textareaClassName,
    selectClassName,
    inputClassName,
    type,
    name,
    onChange: onChangeProp,
    options,
    rows,
    min,
    max,
    step,
    choices
  } = _b, props = __objRest(_b, [
    "className",
    "textareaClassName",
    "selectClassName",
    "inputClassName",
    "type",
    "name",
    "onChange",
    "options",
    "rows",
    "min",
    "max",
    "step",
    "choices"
  ]);
  const form = useFormContext();
  const onChange = useMemo(() => onChangeProp && ((e) => onChangeProp(e.target.value)), [onChangeProp]);
  const register = name !== void 0 ? form == null ? void 0 : form.register(name, options) : void 0;
  switch (type) {
    case "textarea":
      return /* @__PURE__ */ React2.createElement(
        "textarea",
        __spreadValues(__spreadValues({
          className: classNames(className, textareaClassName),
          onChange,
          rows
        }, props), register)
      );
    case "select":
      return /* @__PURE__ */ React2.createElement(
        "select",
        __spreadValues(__spreadValues({
          className: classNames(className, selectClassName),
          onChange
        }, props), register),
        props.placeholder && /* @__PURE__ */ React2.createElement("option", { value: "", hidden: true }, props.placeholder),
        choices == null ? void 0 : choices.map(({ label, value, disabled = false }) => /* @__PURE__ */ React2.createElement("option", { key: value, value, disabled }, label))
      );
    default:
      return /* @__PURE__ */ React2.createElement(
        "input",
        __spreadValues(__spreadValues({
          className: classNames(className, inputClassName),
          type,
          onChange,
          min,
          max,
          step
        }, props), register)
      );
  }
}

// src/js/Components/RadioGroup.tsx
import useHybridInput2 from "@enymo/react-hybrid-input-hook";
import React3, { createContext as createContext3, useContext as useContext3 } from "react";
var Context3 = createContext3(void 0);
var useRadioGroup = () => useContext3(Context3);
function RadioGroup({
  name,
  value: externalValue,
  onChange: externalOnChange,
  options,
  error: externalError,
  children
}) {
  const { value, onChange, error } = useHybridInput2({ name, externalValue, externalOnChange, externalError, options, defaultValue: null });
  return /* @__PURE__ */ React3.createElement(Context3.Provider, { value: { value, onChange } }, /* @__PURE__ */ React3.createElement(ErrorProvider, { value: error }, children));
}

// src/js/Hooks/GlissadeButtonHook.tsx
import { useDisabled, useLoading } from "@enymo/react-form-component";
import { useCallback as useCallback2, useState } from "react";
function useGlissadeButton({ submit = false, loading, disabled, onClick }) {
  var _a, _b, _c;
  const [loadingState, setLoadingState] = useState(false);
  const loadingContext = useLoading();
  const disabledContext = useDisabled();
  const handleClick = useCallback2(async (...args) => {
    try {
      setLoadingState(true);
      await (onClick == null ? void 0 : onClick(...args));
    } finally {
      setLoadingState(false);
    }
  }, [setLoadingState, onClick]);
  return {
    loading: (_a = loading != null ? loading : submit ? loadingContext : void 0) != null ? _a : loadingState,
    disabled: (_c = (_b = disabled != null ? disabled : disabledContext) != null ? _b : loading) != null ? _c : false,
    onClick: handleClick
  };
}

// src/js/Hooks/GlissadeChoiceHook.tsx
import { useDisabled as useDisabled2 } from "@enymo/react-form-component";
import _ from "lodash";
import { useCallback as useCallback3, useMemo as useMemo2 } from "react";
import { useFormContext as useFormContext2 } from "react-hook-form";
function useGlissadeChoice({
  name,
  options,
  value,
  error,
  disabled,
  checked: checkedProp,
  onChange
}) {
  var _b, _c;
  const radioListContext = useRadioGroup();
  const checkboxListContext = useCheckboxList();
  const form = useFormContext2();
  const disabledContext = useDisabled2();
  const _a = name && form && !radioListContext && !checkboxListContext ? form.register(name, disabled ? void 0 : options) : { onChange: void 0 }, { onChange: onChangeForm } = _a, register = __objRest(_a, ["onChange"]);
  const checked = useMemo2(() => checkedProp != null ? checkedProp : value !== void 0 ? typeof value !== "boolean" && (checkboxListContext == null ? void 0 : checkboxListContext.value.includes(value)) || (radioListContext == null ? void 0 : radioListContext.value) === value : void 0, [checkboxListContext, radioListContext, checkedProp, value]);
  const handleChange = useCallback3((e) => {
    onChange == null ? void 0 : onChange(e.target.checked);
    if (value !== void 0) {
      if (typeof value !== "boolean") {
        checkboxListContext == null ? void 0 : checkboxListContext.toggle(value);
      }
      radioListContext == null ? void 0 : radioListContext.onChange(value);
    }
    onChangeForm == null ? void 0 : onChangeForm(e);
  }, [onChange, radioListContext == null ? void 0 : radioListContext.onChange, checkboxListContext == null ? void 0 : checkboxListContext.toggle, onChangeForm]);
  return __spreadValues({
    checked,
    onChange: handleChange,
    disabled: (_b = disabled != null ? disabled : disabledContext) != null ? _b : false,
    error: error != null ? error : name !== void 0 ? (_c = _.get(form.formState.errors, name)) == null ? void 0 : _c.message : void 0
  }, register);
}

// src/js/Hooks/GlissadeInputHook.tsx
import { useDisabled as useDisabled3 } from "@enymo/react-form-component";
import _2 from "lodash";
import { useFormContext as useFormContext3 } from "react-hook-form";
function useGlissadeInput({ name, error, disabled }) {
  var _a, _b;
  const form = useFormContext3();
  const disabledContext = useDisabled3();
  return {
    error: error != null ? error : name !== void 0 ? (_a = _2.get(form == null ? void 0 : form.formState.errors, name)) == null ? void 0 : _a.message : void 0,
    disabled: (_b = disabled != null ? disabled : disabledContext) != null ? _b : false
  };
}

// src/js/util.ts
function findToggledElement(a, b) {
  if (Math.abs(a.length - b.length) !== 1) {
    throw new Error("Invalid difference between arrays");
  }
  const [smaller, larger] = a.length < b.length ? [a, b] : [b, a];
  const set = new Set(smaller);
  return larger.find((item) => !set.has(item));
}
export {
  CheckboxList,
  ErrorProvider,
  GlissadeInput,
  RadioGroup,
  findToggledElement,
  useCheckboxList,
  useError,
  useGlissadeButton,
  useGlissadeChoice,
  useGlissadeInput,
  useRadioGroup
};
